import { CatalogueService } from 'src/app/angularJS/services/catalogue/catalogue.service';
import { CatalogueHistoryService } from 'src/app/angularJS/services/catalogue/catalogue_history.service';

export class CatalogueHistoryController {

  public static $inject = [
    '$scope',
    '$rootScope',
    '$stateParams',
    'catalogueService',
    'catalogueHistoryService',
    '$translate',
    '$transitions'
  ];

  public catalogueVersion: string;
  public catalogueHistory: Array<any>;
  public catalogueId: string;
  public totalCount: number;
  public perPage: number;
  public selectedIndex: number;

  constructor(
    private $scope,
    private $rootScope,
    private $stateParams,
    private catalogueService: CatalogueService,
    public catalogueHistoryService: CatalogueHistoryService,
    private $translate: ng.translate.ITranslateService,
    private $transitions) {
    this.catalogueId = $stateParams.catalogueId;
    this.catalogueVersion = $stateParams.catalogueVersion;

    this.fetchCollection(1, 15);

    this.$transitions.onSuccess({ to: 'products.catalogue_history' }, () => {
      this.selectedIndex = -1;
    });
  }

  public fetchCollection = (page: number, perPage: number) => {
    this.$rootScope.showSpinner = true;
    return this.catalogueHistoryService.getList(this.catalogueId, page, perPage).then((response) => {
      this.$rootScope.showSpinner = false;
      this.totalCount = response.meta.totalCount;
      this.perPage = response.meta.limit;
      this.catalogueHistory = response.history;
    });
  };

  public getDetails = (history: any) => {
    let details;

    switch (history.action) {
      case 'REPLACE':
        if (history.field === 'fields') {
          details = this.$translate.instant('MULTIPLE_FIELDS_UPDATED');
        } else {
          details = this.$translate.instant('CHANGED_FROM', {
            value: this.$translate.instant(history.field.toUpperCase()),
            before: history.oldValue,
            after: history.newValue
          });
        }
        break;
      case 'ADD':
        details = this.$translate.instant('CATALOGUE_DETAIL.ADD_ACTION', {
          value: angular.fromJson(history.value).name
        });
        break;
      case 'REMOVE':
        details = this.$translate.instant('CATALOGUE_DETAIL.REMOVE_ACTION', {
          value: angular.fromJson(history.value).name
        });
        break;
      default:
        details = '';
    }
    return details;
  }
}